import React from 'react';
import { Avatar, Box, Chip, Typography } from '@mui/material';
import { MdPhotoCamera } from 'react-icons/md';
import { Button } from '@mui/material';
import { API_URL } from '../../Utils/url';

export const FONT = 'Mulish, sans-serif';

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const img = (p) => (p ? (p.startsWith('http') || p.startsWith('blob:') ? p : `${API_URL.replace(/\/api\/?$/, '/')}${p.replace(/^\//, '')}`) : undefined);
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');
export const person = (u) => (u && typeof u === 'object' ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email : null);

export const yellowBtn = { textTransform: 'none', fontWeight: 800, background: 'rgb(255 209 2)', color: 'black', borderRadius: '10px', px: 3, boxShadow: '0 4px 12px rgba(255, 209, 2, 0.3)', '&:hover': { background: 'rgb(255 190 0)' } };
export const head = { fontFamily: FONT, fontWeight: 800, fontSize: 12.5, color: '#475569', background: '#f8fafc', whiteSpace: 'nowrap' };
export const cell = { fontFamily: FONT, fontSize: 13.5 };
export const iconBtn = (c) => ({ color: c, background: `${c}14`, borderRadius: '8px', '&:hover': { background: `${c}26` } });

export const Kpi = ({ title, value, from, to, active, onClick }) => (
  <Box onClick={onClick} sx={{ flex: 1, minWidth: 150, p: 2, borderRadius: '16px', color: '#fff', background: `linear-gradient(135deg,${from},${to})`, cursor: onClick ? 'pointer' : 'default', outline: active ? '3px solid #0f172a' : 'none', outlineOffset: 2 }}>
    <Typography sx={{ fontFamily: FONT, fontSize: 12.5, opacity: 0.9, fontWeight: 700 }}>{title}</Typography>
    <Typography sx={{ fontFamily: FONT, fontSize: 26, fontWeight: 800, lineHeight: 1.15 }}>{value}</Typography>
  </Box>
);

export const StatusChip = ({ active }) => (
  <Chip size="small" label={active ? 'Active' : 'Inactive'} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: active ? '#dcfce7' : '#f1f5f9', color: active ? '#166534' : '#475569' }} />
);

export const Row = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, py: 1, borderBottom: '1px dashed #e2e8f0' }}>
    <Typography sx={{ fontFamily: FONT, fontSize: 13, color: '#64748b' }}>{label}</Typography>
    <Typography component="div" sx={{ fontFamily: FONT, fontSize: 13.5, fontWeight: 700, textAlign: 'right', wordBreak: 'break-word' }}>{value || value === 0 ? value : '—'}</Typography>
  </Box>
);

export const Thumb = ({ item, size = 40 }) => (
  <Avatar variant="rounded" src={img(item.image)} sx={{ width: size, height: size, bgcolor: '#e0e7ff', color: '#3730a3', fontWeight: 800, fontSize: size * 0.4 }}>
    {(String(item.title || 'C')[0] || 'C').toUpperCase()}
  </Avatar>
);

// logo / photo picker with preview and remove-less replace (these records must keep an image)
export const ImagePicker = ({ file, preview, name, error, onPick }) => {
  const choose = (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (!f) return;
    if (!f.type.startsWith('image/')) return onPick(null, 'Choose an image file');
    if (f.size > 5 * 1024 * 1024) return onPick(null, 'The image must be under 5 MB');
    onPick(f, null);
  };
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Avatar variant="rounded" src={file ? URL.createObjectURL(file) : img(preview)} sx={{ width: 84, height: 84, bgcolor: '#e0e7ff', color: '#3730a3', fontSize: 30, fontWeight: 800 }}>{(String(name || 'C').trim()[0] || 'C').toUpperCase()}</Avatar>
      <Box>
        <Button component="label" startIcon={<MdPhotoCamera />} sx={{ textTransform: 'none', fontWeight: 700, border: '1px solid #cbd5e1', borderRadius: '10px', color: '#0f172a' }}>
          {file || preview ? 'Change image' : 'Upload image *'}<input hidden type="file" accept="image/*" onChange={choose} />
        </Button>
        <Typography sx={{ fontFamily: FONT, fontSize: 12, color: error ? '#d32f2f' : '#94a3b8', mt: 0.75 }}>{error || 'Required. JPG or PNG, under 5 MB.'}</Typography>
      </Box>
    </Box>
  );
};
